import bitbucket from '../Assets/Images/logos/bitbucket.png'
import css from '../Assets/Images/logos/css.png'
import ex from '../Assets/Images/logos/ex.png'
import fire from '../Assets/Images/logos/fire.png'
import git from '../Assets/Images/logos/git.png'
import github from '../Assets/Images/logos/github.png'
import graph from '../Assets/Images/logos/graph.png'
import html from '../Assets/Images/logos/html.png'
import jest from '../Assets/Images/logos/jest.png'
import js from '../Assets/Images/logos/js.png'
import npm from '../Assets/Images/logos/npm.png'
import postgres from '../Assets/Images/logos/postgres.png'
import react from '../Assets/Images/logos/react.png'
import sass from '../Assets/Images/logos/sass.png'
import wp from '../Assets/Images/logos/wp.png'
import php from '../Assets/Images/logos/php.png'
import laravel from '../Assets/Images/logos/laravel.png'

export let logos = [
  {
    "id": 1,
    "src": html,
    "alt": "Html5 logo",
    "title": "HTML"
  },
  {
    "id": 2,
    "src": css,
    "alt": "CSS3 logo",
    "title": "CSS"
  },
  {
    "id": 3,
    "src": js,
    "alt": "JavaScript logo",
    "title": "JS"
  },
  {
    "id": 4,
    "src": sass,
    "alt": "Sass logo",
    "title": "SASS"
  },
  {
    "id": 5,
    "src": react,
    "alt": "React.js logo",
    "title": "React"
  },
  {
    "id": 6,
    "src": jest,
    "alt": "Jest logo",
    "title": "Jest"
  },
  {
    "id": 7,
    "src": npm,
    "alt": "Npm logo",
    "title": "NPM"
  },
  {
    "id": 8,
    "src": ex,
    "alt": "Express.js logo",
    "title": "Express"
  },
  {
    "id": 9,
    "src": postgres,
    "alt": "PostgresQL logo",
    "title": "Postgres"
  },
  {
    "id": 10,
    "src": php,
    "alt": "PHP logo",
    "title": "PHP"
  },
  {
    "id": 11,
    "src": laravel,
    "alt": "Laravellogo",
    "title": "Laravel"
  },
  {
    "id": 12,
    "src": graph,
    "alt": "GraphQLlogo",
    "title": "GraphQL"
  },
  {
    "id": 13,
    "src": git,
    "alt": "Git logo",
    "title": "Git"
  },
  {
    "id": 14,
    "src": github,
    "alt": "GitHub logo",
    "title": "GitHub"
  },

  {
    "id": 15,
    "src": wp,
    "alt": "WordPress logo",
    "title": "WordPress"
  },
  {
    "id": 16,
    "src": fire,
    "alt": "FireBase logo",
    "title": "FireBase"
  },
  {
    "id": 17,
    "src": bitbucket,
    "alt": "BitBucket logo",
    "title": "Bitbucket"
  }
]